import type { VerificationStateValues } from '@repo/common';

import { VerificationState } from '@repo/common';

export function getAnalyticsResultByVerificationState(verificationResult: VerificationStateValues) {
  return verificationResult === VerificationState.VERIFIED ? 'accept' : 'reject';
}

export function getPublicAsset(relativePath: string): string {
  const assetPath = relativePath.charAt(0) === '/' ? relativePath.slice(1) : relativePath; // if path starts with "/" remove it
  const basePath = import.meta.env.VITE_APP_BASE_PATH;

  return basePath ? `${basePath}/${assetPath}` : `/${assetPath}`;
}
